var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-app-bottom-nav',{attrs:{"id":"nav","nav":_vm.bottomNav,"items":_vm.bottomNavItems,"animation":_vm.animation,"active-class":"primary-color"},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }